import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { Fragment, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReportType } from '@/redux/features/typesOfReportsSlice';
import { useAppSelector } from '@/redux/store';



export default function SearchInput() {

    const listaDeTiposInformes = useAppSelector((state) => state.reports.listaDeTiposDeInforme)

    const listAutocomplete = useMemo(() => {
        return Array.isArray(listaDeTiposInformes) ? listaDeTiposInformes : Object.values(listaDeTiposInformes);
    }, [listaDeTiposInformes]);


    const [busqueda, setBusqueda] = useState<ReportType>();

    const navigate = useNavigate();
    const location = useLocation();


    const irAInforme = () => {
        if (busqueda === undefined) return;
        if (location.pathname === `/informe/${busqueda.path}`) return;


        navigate(`/informe/${busqueda.path}`)
    }

    return (
        <Autocomplete

            disablePortal
            id="searchNavbar"
            onChange={(event: any, newValue: any | null) => {
                setBusqueda(newValue[0]);
            }}
            onKeyDown={(event) => {
                if (event.key === 'Enter' && busqueda !== null) {
                    irAInforme();
                }
            }}
            handleHomeEndKeys
            options={listAutocomplete}
            getOptionLabel={(option: any) => option[0].nombre}
            ListboxProps={{ style: { maxHeight: 150 } }}
            sx={{
                width: '50%', placeSelf: 'center', display: { xs: 'none', md: 'flex' }

            }}
            renderInput={(params) => <TextField {...params} sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: "50px",
                }
            }}
                placeholder='Buscar informe'
                InputProps={{
                    ...params.InputProps,
                    startAdornment: (
                        <Fragment>
                            <SearchIcon sx={{
                                color: 'action.active', ml: 1,
                                '&:hover': {
                                    scale: busqueda && '1.1',
                                    cursor: busqueda && 'pointer',
                                }
                            }}
                                titleAccess={busqueda ? 'Buscar' : 'No hay nada para buscar'}
                                onClick={irAInforme}
                            />
                            {params.InputProps.startAdornment}
                        </Fragment>

                    ),
                }}
            />}
        />
    );
}

